// Permisos por pagina de mantenimiento.
//
// El permiso sale de los accesos del usuario (accesos seeded en la tabla
// acceso, con codigo pagina.accion). Mientras la seguridad este desactivada
// (parametro SEGURIDAD_ACTIVA = 'N') o aun no se hayan cargado los accesos,
// todo se permite: es el comportamiento de siempre, para poder trabajar sin dar
// de alta los roles.
//
// La lista de paginas queda aqui para el menu y los botones; el permiso real lo
// resuelve useMantenimiento con los accesos del usuario.
const PERMISOS_POR_DEFECTO = {
    persona: { ver: true, editar: true },
    modelo: { ver: true, editar: true },
    periodo: { ver: true, editar: true },
    terapia: { ver: true, editar: true },
    terapiaPlan: { ver: true, editar: true },
    terapiaPeriodo: { ver: true, editar: true },
    terapiaPeriodoPago: { ver: true, editar: true },
    sesion: { ver: true, editar: true },
    participante: { ver: true, editar: true },
    conceptoCobro: { ver: true, editar: true },
    comprobante: { ver: true, editar: true },
    catalogo: { ver: true, editar: true },
    trabajador: { ver: true, editar: true },
    usuario: { ver: true, editar: true },
    rol: { ver: true, editar: true },
    autorizacion: { ver: true, editar: false },
};

const getPermiso = (pagina) =>
    PERMISOS_POR_DEFECTO[pagina] ?? { ver: true, editar: true };

export const puedeVerPagina = (pagina) => getPermiso(pagina).ver;

export const puedeEditarPagina = (pagina) => getPermiso(pagina).editar;

// True si el usuario tiene el acceso "pagina.accion". Con la seguridad
// desactivada o sin accesos cargados, se concede.
export const tieneAcceso = (accesos, codigoAcceso) => {
    if (!accesos || accesos.length === 0) return true;

    return accesos.includes(codigoAcceso);
};

export default { puedeVerPagina, puedeEditarPagina, tieneAcceso };